var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "messages-container"
  }, [_c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, _vm._l((_vm.messages), function(m) {
    return _c('div', {
      key: m._id,
      class: ("message alert alert-" + (m.type))
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(m.text)
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "close",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.closeMessage(m._id)
        }
      }
    }, [_vm._v("×")])])
  }))], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4641b570", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4641b570","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./application/components/messages.vue
// module id = 226
// module chunks = 3